import { ContentBlock, Box, Stack, Column, Columns } from 'braid-design-system';
import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';

import {
  FEATURE_PER_UNIT_BILLING,
  useFeatureToggleData,
} from 'src/app/shared/featureToggle';
import { ViewAdLink } from 'src/app/v1/views/components/ViewAdLink';
import type { AppState } from 'src/types/appState';

import { FraudDelayMessage } from '../FraudDelayMessage';
import { ThankYouTick } from '../ThankYouTick';

export const SuccessHeader = () => {
  const { hirerIsNew } = useSelector(
    (state: AppState) => ({
      hirerIsNew: state.session.hirerIsNew,
    }),
    shallowEqual,
  );

  const isPerUnitBilling = useFeatureToggleData(FEATURE_PER_UNIT_BILLING);

  return (
    <ContentBlock>
      <Box
        paddingTop="large"
        paddingBottom="none"
        paddingX={['medium', 'medium', 'none']}
      >
        <Stack space="medium">
          <Columns space="gutter" alignY="center" collapseBelow="tablet">
            <Column>
              <ThankYouTick />
            </Column>
            <Column width="content">
              {!isPerUnitBilling && <ViewAdLink />}
            </Column>
          </Columns>
          {hirerIsNew && <FraudDelayMessage />}
        </Stack>
      </Box>
    </ContentBlock>
  );
};
